
























import Vue from "vue";
import { PropType } from "vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Radio from "@/components/Atoms/Forms/Radio/index.vue";

export interface Data {}

export interface Computed {}

export interface Props {
  value: "company" | "university";
}
export interface Methods {
  handleChange: (value: Props["value"]) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "FollowSelect",
  components: {
    Heading,
    Radio
  },
  props: {
    value: {
      type: String as PropType<Props["value"]>,
      required: true
    }
  },
  methods: {
    handleChange(value) {
      switch (value) {
        case "company":
          this.$router
            .push({ name: "SettingsFollowsCompanies" })
            .catch(err => err);
          return;

        case "university":
          this.$router
            .push({ name: "SettingsFollowsUniversities" })
            .catch(err => err);
          return;
      }
    }
  }
});
